module.exports = __webpack_public_path__ + "img/cv-template-4.d89947b9.png";